<template>
    <span>
        <button type="button" class="btn btn-trans ml-sm-2" data-toggle="dropdown">
            <i class="material-icons">more_horiz</i>
        </button>
        <div class="dropdown-menu dropdown-menu-right text-left">
            <!-- <div class="btn-group-vertical" role="group"> -->
            <ul class="list-unstyled mb-0">
                <template v-for="action in actions">
                    <li :key="action.name">
                        <a :href="formatLink(action.link)"
                           :key="action.name"
                           class="dropdown-item">{{ action.label || action.name }}</a>
                    </li>
                </template>
            </ul>
            <!-- </div> -->
        </div>
    </span>
</template>
<script>

export default {
    props: ['config', 'content'],

    computed: {
        actions() {
            return _.get(this.config, 'actions', [])
                .map(action => {
                    let link = _.get(action, 'link');

                    if (_.isFunction(link)) {
                        link = link(this.content, _);
                    }

                    return {
                        ...action, link,
                    }
                })
        }
    },

    methods: {
        formatLink(link) {
            return '#' + this.helpers('uriFormat')(link);
        },
    },
}
</script>




// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/DropdownActionsButtonComponent.vue